import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function CheckedCircleIcon(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path d="M10.3062 15.1492L7.45522 12.2982L6.48438 13.2622L10.3062 17.0841L18.5105 8.87977L17.5465 7.91577L10.3062 15.1492Z" />
      <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="2" fill="none" />
    </IconWrapper>
  );
}
